import React from 'react'
import Header from '../Components/Header/Header.js'
import ProductForm from '../Components/ProductForm/ProductForm.js'

function ProductUploadPage() {
  return (
    <div>
        <Header/>
        <ProductForm/>
    </div>
  )
}

export default ProductUploadPage